export default __webpack_public_path__ + "static/media/SunIcon_Black.ecba8710.png";